// Copyright 2017 Rigo Investment Sagl.
// This file is part of RigoBlock.

import Contracts from './contracts'

export default Contracts
